/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Turn_ProfileInputs */

const en_us2_body_assessment_cue_turn_profile = /** @type {(inputs: Body_Assessment_Cue_Turn_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn sideways to the phone.`)
};

const pt_br2_body_assessment_cue_turn_profile = /** @type {(inputs: Body_Assessment_Cue_Turn_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vire de perfil.`)
};

const es_419_body_assessment_cue_turn_profile = /** @type {(inputs: Body_Assessment_Cue_Turn_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponte de perfil al teléfono.`)
};

const pt_pt2_body_assessment_cue_turn_profile = /** @type {(inputs: Body_Assessment_Cue_Turn_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vira-te de perfil.`)
};

const fr_fr2_body_assessment_cue_turn_profile = /** @type {(inputs: Body_Assessment_Cue_Turn_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mets-toi de profil.`)
};

const de_de2_body_assessment_cue_turn_profile = /** @type {(inputs: Body_Assessment_Cue_Turn_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dreh dich seitlich zum Handy.`)
};

const it_it2_body_assessment_cue_turn_profile = /** @type {(inputs: Body_Assessment_Cue_Turn_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettiti di profilo.`)
};

/**
* | output |
* | --- |
* | "Turn sideways to the phone." |
*
* @param {Body_Assessment_Cue_Turn_ProfileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_turn_profile = /** @type {((inputs?: Body_Assessment_Cue_Turn_ProfileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Turn_ProfileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_turn_profile(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_turn_profile(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_turn_profile(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_turn_profile(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_turn_profile(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_turn_profile(inputs)
	return en_us2_body_assessment_cue_turn_profile(inputs)
});
export { body_assessment_cue_turn_profile as "body-assessment.cue.turn_profile" }